import { render, staticRenderFns } from "./TableCellSwitch.vue?vue&type=template&id=1bc8ba5c&"
import script from "./TableCellSwitch.vue?vue&type=script&lang=ts&"
export * from "./TableCellSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports